<template>
  <div>
    <d-form-row class="justify-content-end">
      <!-- Desconto -->
      <d-col md="12" lg="4" xl="2" cols="12" class="form-group mb-0">
        <label for="feDesconto">Desconto</label>
        <d-input-group class="mb-3 discount">
          <d-input-group-addon prepend>
            <select class="input-group-text form-control custom-select" v-model="group.discount_type">
              <option value="pct" selected>%</option>
              <option value="value">R$</option>
            </select>
          </d-input-group-addon>
          <input-currency
            model-index="discount"
            placeholder="Desconto"
            hiddenGroup=""
            :parameter="index"
            :model="group"
          />
        </d-input-group>
      </d-col>
    </d-form-row>

    <!-- Mostrar pagamento à vista parcelado -->
    <d-form-row class="justify-content-end">
      <d-col cols="6" class="form-group text-rigth">
        <d-form-row class="justify-content-end">
          <label class="mr-3">Exibir pagamento à vista parcelado</label>
          <d-checkbox toggle @change="togglePaymentSpot" :checked="group.payment_spot == 1" class="custom-toggle-sm mr-2">Sim</d-checkbox>
        </d-form-row>
      </d-col>
    </d-form-row>

    <!-- Pagamento à vista parcelado -->
    <d-form-row class="justify-content-end" v-if="group.payment_spot == 1 && group.installments_by_types.spot">
      <d-col lg="9" xl="3" cols="12" class="form-group">
        <d-card class="pb-2">
          <d-card-header>
            <h6 class="m-0">Valor à vista parcelado</h6>
          </d-card-header>
          <d-form-row class="px-3 justify-content-end">
            <!-- Entrada -->
            <d-col md="8" cols="12" class="form-group mb-0">
              <label>Entrada</label>
              <d-input-group class="mb-2 discount">
                <d-input-group-addon prepend>
                  <select class="input-group-text form-control custom-select" v-model="group.installments_by_types.spot[0].entree_type">
                    <option value="pct" selected>%</option>
                    <option value="value">R$</option>
                  </select>
                </d-input-group-addon>
                <input-currency
                  model-index="entree_value"
                  placeholder="Entrada"
                  hiddenGroup=""
                  :parameter="0"
                  :model="group.installments_by_types.spot[0]"
                />
              </d-input-group>
            </d-col>

            <!-- Parcelas -->
            <d-col md="4" cols="12" class="form-group mb-0">
              <label>Parcelas</label>
              <d-form-input
                type="number"
                class="text-right"
                min="1"
                v-model="group.installments_by_types.spot[0].parcel"
              />
            </d-col>
          </d-form-row>
        </d-card>
      </d-col>
    </d-form-row>

    <!-- Pagamento à prazo (tipo 7) -->
    <d-form-row class="justify-content-end" v-if="group.payment_id == 7">
      <d-col lg="9" xl="3" cols="12" class="form-group">
        <d-card class="pb-2">
          <d-card-header>
            <h6 class="m-0">Valores à prazo</h6>
          </d-card-header>
          <d-form-row class="px-3 justify-content-end" v-for="(payment, payment_index) in group.installments_by_types.forward" :key="payment_index">
            <!-- Entrada -->
            <d-col md="7" cols="12" class="form-group mb-0">
              <label>Entrada</label>
              <d-input-group class="mb-2 discount">
                <d-input-group-addon prepend>
                  <select class="input-group-text form-control custom-select" v-model="payment.entree_type">
                    <option value="pct" selected>%</option>
                    <option value="value">R$</option>
                  </select>
                </d-input-group-addon>
                <input-currency
                  model-index="entree_value"
                  placeholder="Entrada"
                  hiddenGroup=""
                  :parameter="index"
                  :model="payment"
                />
              </d-input-group>
            </d-col>

            <!-- Parcelas -->
            <d-col md="3" cols="12" class="form-group mb-0">
              <label>Parcelas</label>
              <d-form-input
                type="number"
                class="text-right"
                min="1"
                v-model="payment.parcel"
              />
            </d-col>

            <!-- Botões de + e - -->
            <d-col md="2" cols="2">
              <div class="d-flex justify-content-end align-items-center h-100 pt-4">
                <i class="fas fa-plus text-success mr-2" @click="addInstallment()" v-if="showAddNewInstallment(group.installments_by_types.forward, payment_index)"></i>
                <i class="fas fa-minus text-danger" @click="removeInstallment(payment_index)" v-if="group.installments_by_types.forward.length > 1"></i>
              </div>
            </d-col>
          </d-form-row>
        </d-card>
      </d-col>
    </d-form-row>

    <!-- Condição e Forma de pagamento -->
    <d-form-row class="justify-content-end">
      <!-- Condição -->
      <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
        <label class="payment-field-label">
          Cond. pagamento
          <button type="button" tabindex="-1" aria-hidden="true" class="btn-primary btn-sm py-1 payment-field-label__spacer">Selecionar</button>
        </label>
        <d-select v-model="group.payment_id" @change="calcSubtotal(index)">
          <option :value="option.id" v-for="(option, idx) in paymentTypeOptions" :key="idx">{{ option.name }}</option>
        </d-select>
      </d-col>

      <!-- Forma -->
      <d-col md="12" lg="12" xl="4" cols="12" class="form-group">
        <label class="payment-field-label">
          Forma de pagamento
          <button @click="openObligation('paymentInfo', index)" type="button" class="btn-primary btn-sm py-1">Selecionar</button>
        </label>
        <textarea
          v-model="group.payment_info"
          rows="5"
          class="form-control"
        />
      </d-col>
    </d-form-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import InputCurrency from '_shared/InputCurrency.vue';
import CurrencyMask from '_common/mixins/CurrencyMask';
import MixinValidateForm from '_common/mixins/ValidateForm';

import {
  GROUP,
  PAYMENT,
  PAYMENT_SPOT,
  PAYMENT_TYPE_OPTIONS,
  PRODUCT_UNITS_OPTIONS,
} from './QuotationModel';
import GroupActions from './GroupActions';

export default {
  name: 'payment-methods',
  mixins: [MixinValidateForm, CurrencyMask, GroupActions],
  components: {
    InputCurrency,
  },
  props: {
    group: {
      type: Object,
      default() {
        return cloneDeep(GROUP);
      },
    },
    index: {
      type: Number,
    },
    state: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      errors: {
        total: { required: false },
      },
    };
  },
  computed: {
    paymentTypeOptions() {
      return PAYMENT_TYPE_OPTIONS;
    },
    productUnits() {
      const { productUnits } = this.$store.state.product;
      if (productUnits && productUnits.length) {
        return productUnits;
      }
      return PRODUCT_UNITS_OPTIONS;
    },
    model: {
      get() {
        return this.group;
      },
      set(value) {
        this.$emit('update:groups', value);
      },
    },
  },
  methods: {
    ...mapActions(['getProductUnits']),
    togglePaymentSpot() {
      this.group.payment_spot = this.group.payment_spot === 1 ? 0 : 1;
      this.group.installments_by_types = {
        ...this.group.installments_by_types,
        spot: [cloneDeep(PAYMENT_SPOT)],
      };
    },
    addInstallment() {
      if (this.group.installments_by_types.forward.length < 3) {
        this.group.installments_by_types.forward.push(cloneDeep(PAYMENT));
      }
    },
    removeInstallment(paymentIndex) {
      this.group.installments_by_types.forward.splice(paymentIndex, 1);
    },
    showAddNewInstallment(installments, paymentIndex) {
      return (
        installments.length < 3 && paymentIndex + 1 === installments.length
      );
    },
    getOptions() {
      this.getProductUnits();
    },
    openObligation(type, index) {
      this.openContractItemSelect(type, index, this.group);
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
.payment-field-label {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  &__spacer {
    flex: 0 0 0;
    width: 0;
    min-width: 0;
    margin: 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow: hidden;
    visibility: hidden;
    white-space: nowrap;
    border-left-width: 0;
    border-right-width: 0;
    pointer-events: none;

    @media (max-width: 1199.98px) {
      display: none;
    }
  }
}
</style>
